import { useAuthState, type AuthUser } from "../../context/auth";

export type AdminGate = "pending" | "allowed" | "denied";

export function useAdminGate(
  isAllowed: (user: AuthUser | null | undefined) => boolean
): AdminGate {
  const { currentUser, isPendingAuthentication } = useAuthState();
  if (isPendingAuthentication) return "pending";
  return isAllowed(currentUser) ? "allowed" : "denied";
}
